export const showOnSmallDeviceStyle = {
  display: ["revert", "revert", "none"],
};
export const hideOnSmallDeviceStyle = {
  display: ["none", "none", "block"],
};
